import { Subscription, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export class RequestWithFetchStatus<T>{
  observable = new Observable<T>()
  subscription: Subscription;
  private cancelRequest = new Subject<void>();
  private subject = new Subject<T>();

  constructor(){
    this.observable = this.subject.pipe()
  }

  get isLoading(): boolean{
    return !!this.subscription && !this.subscription.closed;
  }

  get hasLoadedSomeTime(): boolean{
    return !!this.subscription
  }

  get(_observable: Observable<T>){
    this.subscription = _observable
      .pipe(takeUntil(this.cancelRequest))
      .subscribe(
        _data => this.subject.next(_data),
        error => console.log(error),
      );

    return this.observable;
  }

  cancel(){
    this.cancelRequest.next();
  }
}
